import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {IExcelColumnList} from '../../shared/model/interface/excel-column.interface';
import {map} from 'rxjs/operators';
import {Base64FileHelper} from '../../shared/helper/base64-file.helper';
import {IBase64File} from '../../shared/model/interface/base64-file.model.interface';
import {IExcelExportRequest} from '../../shared/model/interface/iexcel-export-request.interface';
import {HttpParamsFactory} from '../../shared/factory/http-params.factory';
import {ILegalCaseSearch} from '../../shared/model/interface/legal-case-search.model.interface';
import {IExcelExportSelectedRequest} from '../../shared/model/interface/excel-export-selected.model.interface';
import {
  ILegalCaseExportResponse,
  LegalCaseExportMode
} from '../../shared/model/interface/legal-case-export-response.interface';

@Injectable({
  providedIn: 'root'
})
export class LegalCaseExportService {
  private URL = environment.backendUrl + '/legal-cases/export';

  constructor(private http: HttpClient) {
  }

  public getAvailableColumns() {
    return this.http.get<IExcelColumnList>(this.URL + '/columns');
  }

  public getDataCatalog() {
    return this.http.get<Array<{id: string, name: string, description: string, source: string}>>(this.URL + '/catalog');
  }

  public checkPredefinedExcelAvailable(instructingId: number, instructingGroupId: number) {
    let params = new HttpParams();
    if (instructingId) {
      params = params.append("instructingId", instructingId);
    }
    if (instructingGroupId) {
      params = params.append("instructingGroupId", instructingGroupId);
    }
    return this.http.get<boolean>(this.URL + `/predefined-available`, {params: params});
  }

  exportSelected(exportRequest: IExcelExportSelectedRequest) {
    return this.http.post<IBase64File>(this.URL + '/selected', exportRequest)
      .pipe(
        map(file => Base64FileHelper.decodeFilename(file))
      );
  }

  exportAll(search: ILegalCaseSearch, exportRequest: IExcelExportRequest) {
      const params = HttpParamsFactory.notNullsFromObject(search);
      return this.http.post<ILegalCaseExportResponse>(this.URL + '/auto', exportRequest, {
        params
      }).pipe(
        map(response => ({
          ...response,
          file: response.mode === LegalCaseExportMode.DOWNLOAD && response.file
            ? Base64FileHelper.decodeFilename(response.file)
            : null
        }))
      );
  }

  exportAsync(search: ILegalCaseSearch, exportRequest: IExcelExportRequest, isPredefined: boolean) {
    let params = HttpParamsFactory.notNullsFromObject(search)
    params = params.set('isPredefined', isPredefined.toString())
    return this.http.post<void>(`${this.URL}/async`, exportRequest, {
      params
    });
  }
}
